export default function actionMatchesBase(action, BASE) {
  return action.type && action.type.search(BASE) === 0
}
